const ActivitiesData = [
  {
    id: 1,
    delay: "0",
    title: "Activities",
    img: "images/activities.jpg",
    descriptions: `In honor of Victoria's pharmacists and all the pharmacists in
    both regional and global...`,
  },
  {
    id: 2,
    delay: "400",
    title: "Patient's Testimonial",
    img: "images/testimonial.jpg",
    descriptions: `Successful second case of ischemic stroke patient treated by
    Thrombolytic therapy`,
  },
  {
    id: 3,
    delay: "800",
    title: "Tan Tock Seng Charity Group",
    img: "images/donation.jpg",
    descriptions: `Victoria Hospital offers comprehensive medical services with
    superior quality.`,
  },
];

export default ActivitiesData;
